/**
 * @fileoverview jQuery API wrapper for CharacterCounter
 * jQuery wrapper to allow devs to construct character counters on groups of input/textarea elements
 *
 * Example usage:
 *   <input type="text" class="js-character-counter" data-cc-limit="25" placeholder="Enter text">
 *   <textarea class="js-character-counter big-box" data-cc-on-focus="false">
 *   <input type="text" class="text-limit">
 *  
 *   $('.js-character-counter').characterCounter({ limit: 50 });
 *   $('.text-limit').characterCounter();
 *   
 *   // first will have a limit of 25 characters (from the inline attribute)
 *   // second will have a limit of 50 characters (from the jQuery call)
 *   // third will have whatever limit is default in charactercounter.js
 *  
 * @author Nicholas Cassleman (ncassleman@yext.com)
 */
goog.provide('yext.plugins.characterCounter');

goog.require('yext.textutil.CharacterCounter');

;(function ($, window, document, undefined) {
  'use strict';

    /**
     * @param {?Object=} options
     */
  $.fn.characterCounter = function (options) {
    var args = arguments,
        that = this;

    return this.each(function(index) {
      // check to see if the node has already been initialized
      var cc = $.data(this, 'characterCounter');

      if (!cc) { // if not, assume that we want to initialize it
        var $this = $(this);
        var inlineOptions = {
          counterClass: $this.data('cc-wrap-class'),
          limit: $this.data('cc-limit'),
          label: $this.data('cc-label'),
          labelClass: $this.data('cc-label-class'),
          warningClass: $this.data('cc-warning-class'),
          onFocus: $this.data('cc-on-focus')
        };

        $.data(this, 'characterCounter', new yext.textutil.CharacterCounter(
          $this,
          $.extend({}, options, inlineOptions)));

        if (index === that.length - 1) {
          $this.trigger('ready.characterCounter');
        }
      } else { // if initialized, assume we want to access characterCounter API
        if (typeof options === 'string' &&
            typeof cc[options] === 'function') {
          // calls characterCounter method with the name of the first parameter
          //   with the input parameters of the remaining arguments
          cc[options].apply(cc, Array.prototype.slice.call(args, 1));
        }
      }
    });
  };
})(jQuery, window, document);
